import { SIZE_TO_QUANTITY_MAP } from './constants';

/**
 * Configures the product configurations for the HubSpot credits product. Returns separate sets of product configurations
 * for pricing and purchasing.
 *
 * @param {number | null} creditsSkuId - The SKU ID for the credits product.
 * @param {HubSpotCreditsSize} size - Indicates which size/quantity of credits to purchase.
 * @param {boolean} shouldPurchaseCreditsWithUnlockingProduct - Whether to purchase credits with an unlocking product.
 * @param {number | null} unlockHubSpotCreditsSkuId - The SKU ID for the product that should be bundled with the credits.
 * @returns {Object} - The price and purchase product configurations for the HubSpot credits product.
 */
export const configureHubSpotCreditsProductConfigurations = ({
  creditsSkuId,
  size,
  unlockHubSpotCreditsSkuIds
}) => {
  if (!creditsSkuId) {
    return {
      purchaseProductConfigurations: [],
      unlockHubSpotCreditsProductConfigurations: []
    };
  }
  const creditsProductConfiguration = {
    skuId: creditsSkuId,
    quantity: SIZE_TO_QUANTITY_MAP[size]
  };
  if (unlockHubSpotCreditsSkuIds && unlockHubSpotCreditsSkuIds.length > 0) {
    const unlockHubSpotCreditsProductConfigurations = unlockHubSpotCreditsSkuIds.map(skuId => ({
      skuId,
      quantity: 1
    }));
    return {
      purchaseProductConfigurations: [creditsProductConfiguration, ...unlockHubSpotCreditsProductConfigurations],
      unlockHubSpotCreditsProductConfigurations: [...unlockHubSpotCreditsProductConfigurations]
    };
  }
  return {
    purchaseProductConfigurations: [creditsProductConfiguration],
    unlockHubSpotCreditsProductConfigurations: []
  };
};